<template>
    <div class="modal-privacy">
        <div class="modal-privacy__wrapper">
            <div class="modal-privacy__container">
                <h5 class="modal-privacy__title">Szanujemy Twoją prywatność</h5>
                
                <div class="modal-privacy__text">
                    <p class="modal-privacy__paragraph">Telewizja Polska S.A. w likwidacji pozyskuje dane użytkowników podczas korzystania z Krainy ABC (serwisu krainaabc.tvp.pl oraz aplikacji mobilnej Kraina ABC), zwanej dalej ”Kraina ABC” w tym informacje zapisywane za pomocą technologii służących do ich śledzenia i przechowywania, takich jak pliki Cookies, sygnalizatory WWW lub innych podobnych technologii umożliwiających prawidłowe świadczenie dopasowanych i bezpiecznych usług, oraz analizowanie ruchu w Internecie.</p>
                    <p class="modal-privacy__paragraph">Klikając "Akceptuję i przechodzę dalej", potwierdzasz że wyrażasz zgody na korzystanie z technologii automatycznego śledzenia i zbierania danych, dostęp do informacji na Twoim urządzeniu końcowym i ich przechowywanie przez Telewizję Polską S. A. w likwidacji, w celach analitycznych i statystycznych. Szczegółowe informacje o celach i sposobach przetwarzania danych znajdują się w <a href="/polityka" target="_blank">Polityce Prywatności Krainy ABC</a></p>
                </div>

                <div class="modal-privacy__checkboxes">
                    <div class="modal-privacy__checkbox">
                        <input class="modal-privacy__input" :class="{'modal-privacy__input--error' : showError}" type="checkbox" id="rules" name="rules" required v-model="agreements.rulesAgreement">
                        <div class="modal-privacy__labels">
                            <label for="rules" class="modal-privacy__label">* Zapoznałem(łam) się i akceptuję <a href="/regulamin" target="_blank">Regulaminem świadczenia usług</a></label>
                            <span class="modal-privacy__error error" v-if="showError">To pole musi być zaznaczone</span>
                        </div>
                    </div>

                    <div class="modal-privacy__checkbox">
                        <input class="modal-privacy__input" type="checkbox" id="policy" name="policy" v-model="agreements.policyAgreement">
                        <label for="policy" class="modal-privacy__label" >Zapoznałem(łam) się i akceptuję <a href="/polityka" target="_blank">Polityką prywatności Krainy ABC</a></label>
                    </div>
                </div>

                <button class="modal-privacy__btn" @click="confirmHandle(false)">Akceptuję i przechodzę do serwisu</button>
            </div>
        </div>
        <div class="modal-privacy__bg"></div>
    </div>
</template>

<script>
import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

export default {
    name: 'ModalPrivacy',
    data() {
        return {
            agreements: {
                rulesAgreement: false,
                policyAgreement: false
            },
            showError: false
        };
    },    
    watch: {
        agreements: {
            handler: function() {
                if(this.agreements.rulesAgreement) {
                    this.showError = false;
                }
            },
            deep: true,
            immediate: true            
        }
    },  
    methods: {
        confirmHandle(value) {
            if(!this.agreements.rulesAgreement) {
                this.showError = true;
            } else {
                this.showError = false;
                document.body.classList.remove('scroll-lock');
                this.$emit("privacyHandle", value);
                cookies.set("TVP_ABC_PRIVACY", JSON.stringify(this.agreements), "1y");
            }
        }
    }
}
</script>